<template>
  <!-- Note that we use fill-height since it's annoying to have the dialog resize based on search results -->
  <dialog-scroll-lock
    content-class="fill-height" persistent
    :fullscreen="$vuetify.breakpoint.xsOnly" :value="true"
    v-bind="$attrs" v-on="$listeners"
  >

    <v-card class="fill-height d-flex flex-column">
      <div class="flex-grow-0 pa-1 grey lighten-4 d-sm-flex flex-row-reverse flex-wrap align-center">
        <div class="pa-2 flex-grow-1 d-flex justify-end">
          <div class="mr-3 btn-group btn-group-horizontal">
            <v-btn @click="selectAll">
              <v-icon v-html="mdiSelectGroup" />
              <span class="ml-2 hidden-xs-only">Select all</span>
            </v-btn>
            <v-btn :disabled="!staged.length" @click="staged = []">
              <v-icon v-html="mdiSelectRemove" />
              <span class="ml-2 hidden-xs-only">Clear selection</span>
            </v-btn>
          </div>
          <v-btn color="primary" @click="done">Done</v-btn>
        </div>
        <div class="pl-4 pl-md-2 pr-2 py-2 text-right text-sm-left" v-bind:class="{ 'error--text': !staged.length }">
          <div class="text--label-active" v-bind:class="{ 'error--text': error }">
            {{staged.length | pl('design')}} selected (limit {{limit}})
          </div>
        </div>
      </div>

      <v-divider class="flex-grow-0" />

      <catalog-category
        ref="catalog"
        class="flex-grow-1"
        embedded hide-header hide-background
        :breadcrumbs="categories"
        :category="categories.last"
        :highlight="stagedDesignIds"
        @click:category="v => {
          categories = categories.includes(v) ? (categories.slice(0, categories.indexOf(v) + 1)) : [ ...categories, v ];
        }"
        @select="toggle"
      />

    </v-card>
  </dialog-scroll-lock>
</template>


<script>
import CatalogCategory from '@/views/CatalogCategory.vue';
import { publicDesign } from '@/mixins/public-design.js';
import { mdiClose, mdiSelectGroup, mdiSelectRemove } from '@mdi/js';


export default {
  name: 'select-designs-dialog',

  mixins: [ publicDesign ],

  components: {
    CatalogCategory
  },

  props: [ 'value', 'limit', 'preserveMetadata' ],

  data() {
    return {
      categories: [ 'all' ],
      staged: []
    };
  },

  computed: {
    error() {
      return !this.staged.length || (this.staged.length > this.limit);
    },

    stagedDesignIds() {
      return this.staged.map(x => x.id);
    }
  },

  created() {
    Object.assign(this, { mdiClose, mdiSelectGroup, mdiSelectRemove });
  },

  methods: {
    toggle(id) {
      const i = this.staged.findIndex(x => x.id == id);
      if (i == -1) {
        const { header, query } = this.$refs.catalog;
        this.staged.push({ id, category: header.name, query });
        this.getPublicDesign(id);
      } else {
        this.staged.splice(i, 1);
      }
    },

    selectAll() {
      const { catalog, header, query } = this.$refs.catalog;
      this.staged = catalog.map(x => ({ id: x.id, category: header.name, query })).slice(0, this.limit);
      if (catalog.length > this.limit)
        this.$notify(`Selection limited to first ${this.limit} designs`);
    },

    done() {
      if (this.staged.length > this.limit)
        return this.$confirm({
          title: 'Too many selected',
          msg: `Please limit your selection to at most ${this.limit} designs`,
          buttons: [ 'Ok' ],
          primary: 'Ok'
        });
      this.$emit('input', this.preserveMetadata ? this.staged : this.stagedDesignIds);
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.staged = this.preserveMetadata ? v.slice() : v.map(x => ({ id: x, category: 'all', query: '' }));
      }
    }
  }
}
</script>
